<template>
  <div style="width: 100%">
    <div class="table_box">
      <div class="contentTable">
        <table ref="table" class="table">
          <!-- 表头 -->
          <tr class="top">
            <th
              :class="index_th <= app_fix_col_count ? 'thTitleIsFixed' : ''"
              :style="computedThStyleLeft(item_th, index_th)"
              v-for="(item_th, index_th) in data.tableHeaderData"
              :key="index_th"
              style="border-right: 1px solid #dcdfe6"
            >
              <div
                class="title"
                style="word-break: break-all"
                v-html="
                  item_th.indexOf('UUID99001') != -1
                    ? ''
                    : item_th.indexOf('UUID99002') != -1
                    ? ''
                    : item_th
                "
                :style="
                  data.tableGridwidth[index_th]
                    ? {
                        width: data.tableGridwidth[index_th] * 2 + 50 + 'px',
                        'font-size': header_fontsize + 'px',
                        color: data.mustinputData[index_th] ? 'red' : '#000',
                        'text-align': data.fieldvalue_alignArr[index_th]
                          ? data.fieldvalue_alignArr[index_th]
                          : 'center',
                      }
                    : 'min-width:90px;font-size:' + header_fontsize + 'px'
                "
              ></div>
            </th>
          </tr>
          <!--展示列表数据 -->
          <tr
            class="cont"
            v-for="(item_tr, index_tr) in tableData"
            :key="index_tr"
            @click.stop="changeAuditDataByTd(item_tr)"
          >
            <td
              :class="item_td.webFixed ? 'tdTitleIsFixed' : ''"
              v-for="(item_td, index_td) in item_tr"
              :key="index_td"
              :style="computedTdStyleLeft(item_td)"
              style="border-right: 1px solid #dcdfe6"
              v-show="!item_td.hideData"
            >
              <div class="comm_box">
                <template v-if="item_td.webFiledNum == 1">
                  <input type="checkbox" v-model="item_td.webContent" />
                  <span
                    style="position: relative; top: -1px; margin-left: 1px"
                    >{{ computedTdIndex(index_tr + 1) }}</span
                  >
                </template>
                <template v-else-if="item_td.webFiledNum == 2">
                  <div
                    :style="{ 'font-size': fontsize + 'px' }"
                    @click="visitXq(item_tr, index_tr)"
                    class="cellinput"
                    style="color: blue; text-decoration: underline"
                  >
                    {{ item_td.webContent }}
                  </div>
                </template>
                <template
                  v-else-if="
                    typeof item_td.webContent == 'boolean' ||
                    item_td.controltype == 'checkbox'
                  "
                >
                  <!-- style="pointer-events: none;" readonly  -->
                  <input
                    type="checkbox"
                    v-model="item_td.webContent"
                    @change="
                      (val) => {
                        valuechage(
                          item_td.webContent,
                          item_td,
                          index_td,
                          index_tr
                        );
                      }
                    "
                    :class="{
                      fieldDisabled:
                        item_td.isreadonly || ischeck || status == 'readonly',
                    }"
                    :disabled="
                      item_td.isreadonly || ischeck || status == 'readonly'
                    "
                  />
                </template>
                <template v-else-if="app_can_edit_grid">
                  <div
                    class="cellinput"
                    :style="{
                      'font-size': fontsize + 'px',
                      'text-align': item_td.fieldvalue_align
                        ? item_td.fieldvalue_align
                        : 'center',
                    }"
                    v-if="item_td.isreadonly || ischeck || status == 'readonly'"
                  >
                    {{ item_td.webContent }}
                  </div>
                  <div v-else>
                    <van-field
                      class="cell-text-input"
                      @change="
                        (val) => {
                          valuechage(
                            item_td.webContent,
                            item_td,
                            index_td,
                            index_tr
                          );
                        }
                      "
                      v-if="item_td.controltype == 'edit'"
                      v-model="item_td.webContent"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                    />
                    <!-- 普通下拉 -->
                    <van-field
                      class="cell-text-input"
                      readonly
                      clickable
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      v-else-if="
                        item_td.controltype === 'combobox' &&
                        !item_td.ispoptree &&
                        item_td.listsql != '@selectmonth' &&
                        item_td.listsql != '@selectyear'
                      "
                      v-model="item_td.webContent"
                      @click="showComBoBoxEvent(item_td, index_td, index_tr)"
                    >
                      <template #right-icon>
                        <!-- 右边下拉图标 -->
                        <van-icon name="arrow-down" />
                      </template>
                    </van-field>
                    <!-- 非员工数 -->
                    <van-field
                      class="cell-text-input"
                      readonly
                      clickable
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      v-else-if="
                        item_td.controltype === 'combobox' &&
                        item_td.ispoptree &&
                        item_td.poptreename != 'emptree' &&
                        item_td.listsql != '@selectmonth' &&
                        item_td.listsql != '@selectyear'
                      "
                      v-model="item_td.webContent"
                      @click="showComBoBoxEvent(item_td, index_td, index_tr)"
                    >
                      <template #right-icon>
                        <!-- 右边下拉图标 -->
                        <van-icon name="arrow-down" />
                      </template>
                    </van-field>
                    <!-- 员工树 -->
                    <van-field
                      class="cell-text-input"
                      v-else-if="
                        (item_td.controltype == 'combobox' ||
                          item_td.controltype == 'edit') &&
                        item_td.ispoptree &&
                        item_td.poptreename === 'emptree' &&
                        item_td.listsql != '@selectmonth' &&
                        item_td.listsql != '@selectyear'
                      "
                      v-model="item_td.webContent"
                      @change="
                        (val) => {
                          changeEmpname(val, item_td);
                        }
                      "
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                    >
                      <template #right-icon>
                        <!-- 右边下拉图标 -->
                        <van-icon
                          name="arrow-down"
                          @click="
                            showComBoBoxEvent(item_td, index_td, index_tr)
                          "
                        />
                      </template>
                    </van-field>
                    <!-- 年份 -->
                    <van-field
                      class="cell-text-input"
                      v-else-if="
                        item_td.controltype === 'combobox' &&
                        item_td.listsql == '@selectyear'
                      "
                      v-model="item_td.webContent"
                      readonly
                      clickable
                      @click="settingYear(item_td, index_td, index_tr)"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                    >
                      <template #right-icon>
                        <div style="display: flex; align-items: center">
                          <van-icon
                            v-if="item_td.webContent"
                            @click.stop="
                              () => {
                                item_td.webContent = '';
                              }
                            "
                            style="margin-right: 5px"
                            name="close"
                          />
                          <svg-icon icon-class="calendarIcon"></svg-icon>
                        </div>
                      </template>
                    </van-field>
                    <!-- 月份 -->
                    <van-field
                      class="cell-text-input"
                      v-else-if="
                        item_td.controltype === 'combobox' &&
                        item_td.listsql == '@selectmonth'
                      "
                      v-model="item_td.webContent"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      readonly
                      clickable
                      @click="settingYearMonth(item_td, index_td, index_tr)"
                    >
                      <template #right-icon>
                        <div style="display: flex; align-items: center">
                          <van-icon
                            v-if="item_td.webContent"
                            @click.stop="
                              () => {
                                item_td.webContent = '';
                              }
                            "
                            style="margin-right: 5px"
                            name="close"
                          />
                          <svg-icon icon-class="calendarIcon"></svg-icon>
                        </div>
                      </template>
                    </van-field>
                    <!-- 日期框 -->
                    <van-field
                      class="cell-text-input"
                      readonly
                      clickable
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      v-else-if="item_td.controltype == 'datetime'"
                      v-model="item_td.webContent"
                      @click="
                        !(
                          tem_td.isreadonly ||
                          ischeck ||
                          status == 'readonly'
                        ) && settingDatetime(item_td, index_td, index_tr)
                      "
                    >
                      <template #right-icon>
                        <div style="display: flex; align-items: center">
                          <van-icon
                            v-if="item_td.webContent"
                            @click.stop="
                              () => {
                                item_td.webContent = '';
                              }
                            "
                            style="margin-right: 5px"
                            name="close"
                          />
                          <svg-icon icon-class="calendarIcon"></svg-icon>
                        </div>
                      </template>
                    </van-field>
                    <!-- 详细的时间和日期 -->
                    <van-field
                      class="cell-text-input"
                      readonly
                      clickable
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      v-else-if="item_td.controltype == 'longdatetime'"
                      @click="
                        !(
                          item_td.isreadonly ||
                          ischeck ||
                          status == 'readonly'
                        ) && settingLongDatetime(item_td, index_td, index_tr)
                      "
                      v-model="item_td.webContent"
                    >
                      <template #right-icon>
                        <div style="display: flex; align-items: center">
                          <van-icon
                            v-if="item_td.webContent"
                            @click.stop="
                              () => {
                                item_td.webContent = '';
                              }
                            "
                            style="margin-right: 5px"
                            name="close"
                          />
                          <svg-icon icon-class="calendarIcon"></svg-icon>
                        </div>
                      </template>
                    </van-field>
                    <!-- 表格下拉框 -->
                    <van-field
                      class="cell-text-input"
                      readonly
                      clickable
                      v-else-if="item_td.controltype == 'lookupcombobox'"
                      v-model="item_td.webContent"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      @click="showComBoBoxEvent(item_td, index_td, index_tr)"
                    >
                      <template #right-icon>
                        <!-- 右边下拉图标 -->
                        <van-icon name="arrow-down" />
                      </template>
                    </van-field>
                    <!-- 进度条 -->
                    <van-field
                      class="cell-text-input"
                      v-else-if="
                        item_td.controltype == 'maskedit' &&
                        item_td.maskeditstr == 'Slider'
                      "
                      v-model="item_td.webContent"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                    >
                      <template #input>
                        <div style="width: 100%; height: 100%; padding: 0 20px">
                          <van-slider
                            :disabled="
                              item_td.isreadonly ||
                              ischeck ||
                              status == 'readonly'
                            "
                            v-model="item_td.webContent"
                          >
                            <template #button>
                              <div class="custom-button">
                                {{
                                  item_td.webContent ? item_td.webContent : 0
                                }}
                              </div>
                            </template>
                          </van-slider>
                        </div>
                      </template>
                    </van-field>
                    <van-field
                      class="cell-text-input"
                      type="textarea"
                      v-else-if="item_td.controltype == 'memo'"
                      v-model="item_td.webContent"
                      autosize
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                    >
                    </van-field>
                    <van-field
                      class="cell-text-input"
                      :class="{
                        fieldDisabled:
                          item_td.isreadonly || ischeck || status == 'readonly',
                      }"
                      :disabled="
                        item_td.isreadonly || ischeck || status == 'readonly'
                      "
                      @change="
                        (val) => {
                          valuechage(
                            item_td.webContent,
                            item_td,
                            index_td,
                            index_tr
                          );
                        }
                      "
                      v-else
                      v-model="item_td.webContent"
                    />
                  </div>

                  <!--  -->
                </template>
                <template v-else>
                  <div
                    class="cellinput"
                    :style="{
                      'font-size': fontsize + 'px',
                      'text-align': item_td.fieldvalue_align
                        ? item_td.fieldvalue_align
                        : 'center',
                    }"
                  >
                    {{ item_td.webContent }}
                  </div>
                </template>
              </div>
            </td>
          </tr>
          <tr class="footer">
            <th
              :class="index_th <= app_fix_col_count ? 'thTitleIsFixed' : ''"
              :style="computedThStyleLeft(item_th.webContent, index_th)"
              v-for="(item_th, index_th) in huiZongArr"
              :key="index_th"
              style="border-right: 1px solid #dcdfe6"
              v-show="index_th != huiZongArr.length - 1"
            >
              <div
                class="title"
                :style="
                  data.tableGridwidth[index_th]
                    ? {
                        width: data.tableGridwidth[index_th] * 2 + 40 + 'px',
                        'font-size': header_fontsize + 'px',
                        color: data.mustinputData[index_th] ? 'red' : '#000',
                        'text-align': data.fieldvalue_alignArr[index_th]
                          ? data.fieldvalue_alignArr[index_th]
                          : 'center',
                      }
                    : 'min-width:90px;font-size:' + header_fontsize + 'px'
                "
              >
                <span
                  v-show="
                    item_th.webContent == '汇总'
                      ? true
                      : item_th.footerkind != `skNone`
                  "
                  >{{ item_th.webContent }}</span
                >
              </div>
            </th>
          </tr>
        </table>
      </div>
    </div>
    <div
      class="bottomPage"
      style="margin-top: 3px"
      v-if="b4TableData && b4TableData.length > 0 && pagequery"
    >
      <van-pagination
        class="empPage"
        v-model="currentPage"
        :items-per-page="pageSize"
        :total-items="total"
        :show-page-size="3"
        force-ellipses
        @change="changePage"
      />
    </div>
    <div
      class="caoZuoAnNiu"
      style="margin-top: 3px"
      v-if="(canCopy || canDelete) && showChilendAdd"
    >
      <van-button
        @click="copyItem"
        type="info"
        size="small"
        style="margin-right: 5px"
        v-if="
          $t('workFlow.txt11') &&
          canCopy &&
          (documentType == 5
            ? formConfig.cx_flag == -1
            : documentType == 4
            ? formConfig.cx_flag == 1 || formConfig.cx_flag == 2
            : true)
        "
        >{{ $t('workFlow.txt11') }}</van-button
      >
      <van-button
        @click="deleteItem"
        type="danger"
        size="small"
        style="margin-right: 5px"
        v-if="
          $t('workFlow.txt12') &&
          canDelete &&
          (documentType == 5
            ? formConfig.cx_flag == -1
            : documentType == 4
            ? formConfig.cx_flag == 1 || formConfig.cx_flag == 2
            : true)
        "
        >{{ $t('workFlow.txt12') }}</van-button
      >
    </div>
    <van-dialog
      class="childInfoDialog"
      v-model="show"
      :cancel-button-text="$t('workFlow.txt6')"
      :confirm-button-text="$t('workFlow.txt5')"
      :show-cancel-button="Boolean($t('workFlow.txt6'))"
      :show-confirm-button="
        (documentType == 5
          ? formConfig.cx_flag == -1
          : documentType == 4
          ? formConfig.cx_flag == 1 || formConfig.cx_flag == 2
          : true) && data.app_can_save && Boolean($t('workFlow.txt5'))
      "
      :before-close="beforeClose"
    >
      <childInfo
        v-if="showIt"
        :acceptid="selectObj.acceptid"
        :childIndex="selectIndex"
        :childKey="childKey"
        :macceptid="macceptid"
        :ischeck="ischeck"
        :form="selectObj.form"
        :status="status"
        :saveormodify="saveormodify"
        :formautoid="newformautoid"
        :childObj="data"
        :form-config="formConfig"
        :masterformstr="masterformstr"
        :addStatus="addStatus"
        ref="refChildInfo"
        :dt_whencheck_can_delete="dt_whencheck_can_delete"
        :dt_whencheck_can_insert="dt_whencheck_can_insert"
        operatingMode="2"
      >
      </childInfo>
    </van-dialog>
    <!-- combobox控件 -->
    <van-popup v-model="showComboboxPicker" position="bottom">
      <van-picker
        :title="selectFormdata.chnname"
        show-toolbar
        value-key="dicvalue"
        :columns="comboboxChoices"
        @cancel="showComboboxPicker = false"
        @confirm="onComboboxConfirm"
        :default-index="comboboxDefaultIndex"
      />
    </van-popup>
    <!-- lookupCombobox控件 -->
    <van-popup v-model="showLookupComboboxPicker" position="bottom">
      <div style="width: 100%; overflow: hidden; padding: 10px">
        <div class="table_box" style="overflow: auto; background: #fff">
          <table ref="table" class="table">
            <tr
              class="top"
              v-for="(choice, i) in lookupcomboboxChoices.head"
              :key="i + '1'"
            >
              <th v-for="(key, j) in choice.name" :key="j">
                <div
                  style="margin: 0 auto"
                  class="title"
                  :style="
                    choice.width[j]
                      ? { width: choice.width[j] * 10 + 'px' }
                      : 'min-width:90px'
                  "
                  :c="choice.width[j]"
                >
                  {{ key }}
                </div>
              </th>
            </tr>
            <tr
              @click="onLookupComboboxConfirm(choice, i)"
              class="cont"
              v-for="(choice, i) in lookupcomboboxChoices.data"
              :key="i"
              :class="
                choice.indexOf('isLookupcomboboxActive') != -1
                  ? 'isLookupcomboboxActiveBg'
                  : ''
              "
            >
              <td
                v-for="(k, idx) in choice"
                :key="idx"
                v-show="k != 'isLookupcomboboxActive'"
              >
                {{ k }}
              </td>
            </tr>
          </table>
        </div>
        <div class="bottomPage" style="margin-top: 3px">
          <van-pagination
            class="empPage"
            v-model="currentPage2"
            :total-items="lookupcomboboxTotal"
            :show-page-size="3"
            force-ellipses
            @change="lookupcomboboxPageChange"
          />
        </div>
      </div>
    </van-popup>
    <!-- 选择人员树弹窗 -->
    <PopTree
      ref="popTreeNode"
      :whichTree="whichTreeName"
      :module="formConfig.moduleno || formautoid"
      :multiseltree="isMultiselTree"
      @treeSelectValEvent="treeSelectValEvent"
    ></PopTree>
    <!-- 多选员工 -->
    <empDataTable
      :singleSel="true"
      ref="refEmpDataTable"
      @choiceSelect="choiceSelect"
    ></empDataTable>
    <!-- dateTime控件 -->
    <van-popup v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker
        :title="selectFormdata.chnname"
        :formatter="formatter3"
        v-model="currentDatetime"
        type="date"
        @confirm="onDatetimeConfirm"
        @cancel="showDatetimePicker = false"
      />
    </van-popup>
    <!-- longdatetime控件 -->
    <van-popup v-model="showLongDatetimePicker" position="bottom">
      <van-datetime-picker
        :formatter="formatter6"
        :title="selectFormdata.chnname"
        v-model="currentLongDatetime"
        type="datetime"
        :filter="filterTime"
        @confirm="onLongDatetimeConfirm"
        @cancel="showLongDatetimePicker = false"
      />
    </van-popup>
    <!-- 月份控件 -->
    <van-popup v-model="showYearMonthPicker" position="bottom">
      <van-datetime-picker
        :title="selectFormdata.chnname"
        v-model="currentYearMonth"
        type="year-month"
        @confirm="onYearMonthConfirm"
        @cancel="showYearMonthPicker = false"
        :formatter="formatter"
      />
    </van-popup>
    <!-- 年份控件 -->
    <van-popup v-model="showYearPicker" position="bottom" class="hideNfLLL">
      <van-datetime-picker
        :title="selectFormdata.chnname"
        v-model="currentYear"
        type="year-month"
        @confirm="onYearConfirm"
        @cancel="showYearPicker = false"
        :formatter="formatter2"
      />
    </van-popup>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from "vant";
import childInfo from "./childInfo.vue";
import PopTree from "@components/PopTree/index.vue";
import empDataTable from "@components/empDataTable/index.vue";
import selectMultiple from "@/components/selectMultiple/index.vue";
import { paging, createGguid } from "@/utils";
import { parseTime, hex2int, int2hex } from "@/utils";
import { getWFFormFieldDetail, deleteWorkFlowList } from "@api/workFlow";
import { getListSource, getEmpInfo, getQueryEmpModuleNo } from "@api/workFlow";
export default {
  props: {
    // 基本信息
    formConfig: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    // 当前的子表主索引
    childKey: {
      type: [String, Number],
      default: 0,
    },
    // 主表autoid
    macceptid: {
      type: [Number, String],
      default: 0,
    },
    ischeck: {
      type: [String, Boolean],
      default: false,
    },
    // 表单状态（save:新增,modify:修改,readonly:只读）
    status: {
      type: String,
      default: "save",
    },
    // 记录状态（save:新增,modify:修改,readonly:只读  优先度高于status）
    saveormodify: {
      type: String,
      default: "save",
    },
    masterformstr: {
      type: [String, Number],
      default: "",
    },
    dt_whencheck_can_delete: {
      type: Boolean,
      default: false,
    },
    daoChuIng: {
      type: Boolean,
      default: false,
    },
    dt_whencheck_can_insert: {
      type: Boolean,
      default: false,
    },
    // 模块号
    formautoid: {
      type: [String, Number],
      default: "",
    },
    // 点击新增按钮的时候变成true
    addStatus: {
      type: Boolean,
      default: false,
    },
    nodeid: {
      type: [String, Number],
      default: "",
    },
    showChilendAdd: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    childInfo,
    PopTree,
    empDataTable,
    selectMultiple,
  },
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : this.$route.query.formoutSize == "1"
      ? { userid: 1, username: "admin" }
      : {};

    return {
      userInfo,
      selectObj: {},
      selectIndex: 0,
      show: false,
      showIt: false,
      total: 0, // 进度条 总数
      currentPage: 1, // 当前页码
      pageSize: 0, // 每页多少条数据
      bigArray: [],
      tableData: [],
      b4TableData: [],
      newformautoid: this.formautoid,
      pagequery: false,
      b4ChildrenData: [],
      childrenData: [],
      childrenArray: [],
      app_fix_col_count: 1,
      headerheight: 32,
      datarowheight: 32,
      header_fontsize: 12,
      fontsize: 12,
      huiZongArr: [],
      openfooter: false,
      logdetail: "", // 有修改的字段
      formstr: {}, // 保存表单填写数据
      intarry: ["int", "smallint"], // sql整数类型
      floatarry: ["money", "float", "numeric"], // sql小数类型
      selectFormdata: {}, // 选中的字段（用于接收弹窗返回信息）
      comboboxDefaultIndex: 0, // 选择控件的默认值
      showComboboxPicker: false,
      lookupcomboboxTotal: 0, // 进度条 总数
      currentPage2: 1, // 当前页码
      pageSize2: 10, // 每页多少条数据
      searchVal: "", // lookupcombobox模糊搜索值
      lookupcomboboxList: [],
      lookupcomboboxChoices: {
        head: [],
        data: [],
      },
      showLookupComboboxPicker: false,
      loopData: [],
      comboboxChoices: [],
      selectFormdataIndex: 0,
      selectFormdataPIndex: 0,
      whichTreeName: "",
      isMultiselTree: false,
      quemoduleno: "",
      showYearPicker: false,
      currentYear: new Date(),
      showTimePicker: false,
      currentTime: new Date(),
      showYearMonthPicker: false,
      currentYearMonth: new Date(),
      showDatetimePicker: false, // 日期
      currentDatetime: new Date(),
      showLongDatetimePicker: false,
      currentLongDatetime: new Date(),
      app_can_edit_grid: false,
      timer: null,
    };
  },
  watch: {
    data: {
      handler(n) {
        console.log(n.isUpDate, "watch data");
        if (n.isUpDate) {
          clearTimeout(this.timer);
          this.timer = null;
          this.timer = setTimeout(() => {
            if (n && n.tableData && n.tableData.length > 0) {
              this.app_fix_col_count = 1 + n.moduleConfig.app_fix_col_count;
              this.pagequery = n.moduleConfig.pagequery;
              this.pageSize = this.pagequery ? n.moduleConfig.pagesize : 10000;
              this.openfooter = n.moduleConfig.openfooter;
              this.b4TableData = JSON.parse(JSON.stringify(n.tableData));
              this.bigArray = paging(this.pageSize, this.b4TableData);
              this.tableData = this.bigArray[this.currentPage - 1];
              this.headerheight = n.moduleConfig.headerheight || 32;
              this.datarowheight = n.moduleConfig.datarowheight * 3 + 2 || 32;
              this.header_fontsize = n.moduleConfig.header_fontsize || 12;
              this.fontsize = n.moduleConfig.fontsize || 12;
              this.b4ChildrenData = JSON.parse(JSON.stringify(n.children));
              this.childrenArray = paging(this.pageSize, this.b4ChildrenData);
              this.childrenData = this.childrenArray[this.currentPage - 1];
              this.app_can_edit_grid = n.moduleConfig.app_can_edit_grid;
              this.total = n.tableData.length;
              clearTimeout(this.timer);
              this.timer = null;
              this.timer = setTimeout(() => {
                this.upDateSelectArr();
              }, 500);
            }
            this.$forceUpdate();
          }, 36);
        }
      },
      deep: true,
      immediate: true,
    },
    formautoid: {
      handler(n) {
        this.newformautoid = n;
      },
      deep: true,
      immediate: true,
    },
    daoChuIng: {
      handler(n) {
        if (n) {
          const dom = document.querySelectorAll(".contentTable");
          for (let i = 0; i < dom.length; i++) {
            dom[i].scrollLeft = 20;
          }
        } else {
          const dom = document.querySelectorAll(".contentTable");
          for (let i = 0; i < dom.length; i++) {
            dom[i].scrollLeft = 0;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    canCopy() {
      var bool =
        this.data &&
        this.data.moduleConfig &&
        (this.status == "save" ||
          this.status == "check" ||
          this.status == "modify") &&
        (this.status == "check"
          ? this.data.moduleConfig.qj_dt_whencheck_can_insert &&
            this.data.moduleConfig.caninsert &&
            this.dt_whencheck_can_insert
          : this.data.moduleConfig.caninsert);
      return bool;
    },
    canDelete() {
      var bool =
        this.data &&
        this.data.moduleConfig &&
        (this.status == "save" ||
          this.status == "check" ||
          this.status == "modify") &&
        (this.status == "check"
          ? this.data.moduleConfig.qj_dt_whencheck_can_delete &&
            this.data.moduleConfig.candelete &&
            this.dt_whencheck_can_delete
          : this.data.moduleConfig.candelete);
      return bool;
    },
    // 0是没意义的，一般是新增
    // 1：待我审批
    // 2：我发起的
    // 3：我已审批
    // 4：被撤销的
    // 5：未提交的
    // 6：抄送
    documentType() {
      return this.$route.query.documentType || 0;
    },
    computedThStyleLeft() {
      return (value, index) => {
        // 这里会有个报错，但是不用管它 如果要管 套一层try catch 但是一旦移除这个报错 会导致页面重新计算位置
        if (index <= this.app_fix_col_count) {
          let width = 0;
          for (let i = 0; i < index; i++) {
            // 如果客户反馈 在后面 +4-index+1+i
            width = width + (this.data.tableGridwidth[i] * 2 + 40);
          }
          if (index == 0) {
            return (
              "left:" +
              width +
              "px;" +
              "height:" +
              this.headerheight +
              "px;border-left:1px solid #dcdfe6;"
            );
          } else {
            return (
              "left:" + width + "px;" + "height:" + this.headerheight + "px;"
            );
          }
        } else {
          return "height:" + this.headerheight + "px";
        }
      };
    },
    computedTdStyleLeft() {
      // 这里会有个报错，但是不用管它 如果要管 套一层try catch 但是一旦移除这个报错 会导致页面重新计算位置
      return (value) => {
        if (value.webFixed && value.fixedIndex <= this.app_fix_col_count) {
          let width = 0;
          for (let i = 0; i < value.fixedIndex; i++) {
            // 如果客户反馈 在后面 +4-value.fixedIndex+1+i
            width = width + (this.data.tableGridwidth[i] * 2 + 40);
          }
          if (value.fixedIndex == 0) {
            return "left:" + width + "px;border-left:1px solid #dcdfe6;";
          } else {
            return "left:" + width + "px;";
          }
        } else {
          // return 'height:'+this.datarowheight+'px';
        }
      };
    },
    computedTdIndex() {
      return (value) => {
        if (value < 10) {
          return `0${value}`;
        } else {
          return value;
        }
      };
    },
  },
  methods: {
    filterTime(type, options) {
      if (type === "minute") {
        let canshu = 1;
        if (this.selectFormdata.stepmin <= 0 || !this.selectFormdata.stepmin) {
          canshu = 1;
        } else {
          canshu = parseInt(this.selectFormdata.stepmin);
        }
        return options.filter((option) => option % canshu === 0);
      }
      return options;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    formatter2(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return ``;
      }
      return "";
    },
    formatter3(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    formatter5(type, val) {
      if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    formatter6(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    // 年份控件
    settingYear(list, index, pindex) {
      this.selectFormdata = list;
      this.selectFormdataIndex = index;
      this.selectFormdataPIndex = pindex;
      if (list.webContent) {
        this.currentYear = new Date(list.webContent + "-" + "01" + "-01");
      } else {
        this.currentYear = new Date();
      }
      this.showYearPicker = true;
    },
    settingYearMonth(list, index, pindex) {
      this.selectFormdata = list;
      this.selectFormdataIndex = index;
      this.selectFormdataPIndex = pindex;
      if (list.webContent) {
        let yyyy = list.webContent.slice(0, 4);
        let mmmm = list.webContent.slice(4);
        this.currentYearMonth = new Date(yyyy + "-" + mmmm + "-01");
      } else {
        this.currentYearMonth = new Date();
      }
      this.showYearMonthPicker = true;
    },
    // Datetime控件
    settingDatetime(list, index, pindex) {
      this.selectFormdata = list;
      this.selectFormdataIndex = index;
      this.selectFormdataPIndex = pindex;
      this.currentDatetime = list.webContent
        ? new Date(list.webContent)
        : new Date();
      this.showDatetimePicker = true;
    },
    // Datetime控件
    onDatetimeConfirm(time) {
      const v = parseTime(time, "{y}-{m}-{d}");
      this.setValue(this.selectFormdata.fieldname, v);
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          v,
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showDatetimePicker = false;
    },
    padWithZeros(number, length) {
      var str = "" + number;
      while (str.length < length) {
        str = "0" + str;
      }
      return str;
    },
    // longDatetime控件
    settingLongDatetime(list, index, pindex) {
      this.selectFormdata = list;
      this.selectFormdataIndex = index;
      this.selectFormdataPIndex = pindex;
      const yyyy = new Date().getFullYear();
      const mmmm = new Date().getMonth() + 1;
      const dddd = this.padWithZeros(new Date().getDate(), 2);
      const hours = this.padWithZeros(new Date().getHours(), 2);
      const minute = this.padWithZeros(new Date().getMinutes(), 2);
      list.webContent
        ? new Date(list.webContent)
        : yyyy + "-" + mmmm + "-" + dddd + " " + hours + ":00";
      this.currentLongDatetime = list.webContent
        ? new Date(list.webContent)
        : new Date(yyyy + "-" + mmmm + "-" + dddd + " " + hours + ":00:00");
      this.showLongDatetimePicker = true;
    },
    // longDatetime控件
    onLongDatetimeConfirm(time) {
      const v = parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}");
      this.setValue(this.selectFormdata.fieldname, v);
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          v,
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showLongDatetimePicker = false;
    },
    onYearMonthConfirm(time) {
      const v = parseTime(time, "{y}-{m}");
      this.setValue(this.selectFormdata.fieldname, v);
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          v,
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showYearMonthPicker = false;
    },
    onYearConfirm(time) {
      const v = parseTime(time, "{y}");
      this.setValue(this.selectFormdata.fieldname, v);
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          v,
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showYearPicker = false;
    },
    // combobox控件
    onComboboxConfirm(obj) {
      // console.log(this.selectFormdata,obj,'onComboboxConfirm')
      this.setValue(this.selectFormdata.fieldname, obj.dicvalue);
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          obj.dicvalue,
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showComboboxPicker = false;
    },
    // 表单change事件（判断是否触发数据带出）
    valuechage(val, list, index, pindex) {
      if (this.app_can_edit_grid) {
        clearTimeout(this.timer);
        this.timer = null;
        this.upDateSelectArr();
        this.$emit(
          "changeChildInfo",
          list,
          index,
          pindex,
          this.childKey,
          this.app_can_edit_grid
        );
        // this.$emit('update:childData', newVal);
        this.$emit("setCanSave", true);
        this.hasEXfieldlist = [];
        list.haschange = true;
        list.newvalue = val;
        //先触发退出提醒
        if (
          list.isexitshowinfo &&
          list.formdata !== "" &&
          list.formdata !== null
        ) {
          //启用退出提醒
          let fun = this.ExitInfo;
          this.bulidExitValue(list.fieldname, val, fun);
        }
        if (list.isexitvalue) {
          //启用数据带出
          let fun = this.ExitValue;
          this.bulidExitValue(list.fieldname, val, fun);
        }
      }
    },
    // 构造数据带出结构体，发起数据打出请求
    bulidExitValue(n, v, fun) {
      if (this.data && typeof this.data.dtkeyfield != "undefined") {
        this.formstr[this.data.dtkeyfield] = this.macceptid;
      }
      this.updateformstr();
      const totalformstr = JSON.stringify(this.formstr);
      const editstate =
        this.new_acceptid === "" ||
        this.new_acceptid === null ||
        this.new_acceptid === "0" ||
        this.new_acceptid === 0
          ? 1
          : 2;
      const data = {
        editstate: editstate,
        formautoid: this.formautoid,
        fieldname: n,
        fieldvalue: v,
        username: this.userInfo.username,
        formstr: totalformstr,
      };
      if (typeof fun === "function") {
        if (
          typeof data.fieldvalue == "object" &&
          typeof data.fieldvalue.isTrusted != "undefined"
        ) {
          console.log(
            typeof data.fieldvalue,
            typeof data.fieldvalue.isTrusted,
            "类型"
          );
        } else {
          fun(data);
        }
      }
    },
    // 设置字段值（不触发数据带出）
    setValue(n, v, tar = "new") {
      this.loopData =
        this.data.children[this.selectFormdataPIndex].form.loopData;
      this.loopData.forEach((it) => {
        it.children.forEach((i) => {
          if (i.fieldname === n) {
            let vv = v;
            if (i.fielddatatype === "bit") {
              const truearr = [1, "1", "true", "True", "TRUE", true];
              vv = truearr.indexOf(v) != -1 ? true : false;
            } else if (
              (i.controltype === "longdatetime" ||
                i.controltype === "datetime") &&
              vv !== null &&
              !this.ischeck
            ) {
              if (i.controltype === "datetime") {
                vv = parseTime(vv, "{y}-{m}-{d}");
              }
              if (i.datetime === "longdatetime") {
                vv = parseTime(vv, "{y}-{m}-{d} {h}:{i}:{s}");
              }
            } else if (i.controltype === "colorcombobox" && vv !== null) {
              vv = "#" + int2hex(vv);
            } else if (i.controltype === "memo" && vv !== null) {
              vv = vv.toString().replace(/\\n/g, "\n").replace(/\\r/g, "\r");
            } else if (i.controltype === "combobox" && vv !== null) {
              if (i.listsql == "@selectyear") {
                // vv = parseTime(vv, "{y}")
              } else if (i.listsql == "@selectmonth") {
                // vv = parseTime(vv, "{y}-{m}")
              }
            } else if (i.controltype === "checkgroup" && vv) {
              vv = vv.split(",");
            } else if (i.controltype === "checkgroup" && !vv) {
              vv = [];
            } else if (i.controltype === "selectcombobox" && vv) {
              vv = vv.split(",");
            } else if (i.controltype === "selectcombobox" && !vv) {
              vv = [];
            } else if (
              i.controltype === "maskedit" &&
              i.maskeditstr == "Slider"
            ) {
              vv = parseFloat(vv);
              vv = isNaN(vv) ? 0 : vv;
            }
            i.formdata = vv;

            this.selectFormdata.webContent = vv;
            if (tar === "old") {
              i.oldvalue = vv;
              i.haschange = false;
              i.newvalue = "";
            } else if (tar === "new") {
              i.haschange = true;
              i.newvalue = vv;
            }
          }
        });
      });
      this.childrenData[this.selectFormdataPIndex].form.loopData =
        this.loopData;
      this.$emit(
        "changeChildInfo",
        this.selectFormdata,
        this.selectFormdataIndex,
        this.selectFormdataPIndex,
        this.childKey,
        this.app_can_edit_grid
      );
      this.$forceUpdate();
    },
    // 确定树的选择
    treeSelectValEvent(data) {
      this.$emit("setCanSave", true);
      // this.hasEXfieldlist = [];
      if (this.selectFormdata.multiseltree) {
        //多选树
        const namelist = data.map((it) =>
          it.keyname.indexOf(" ") != -1 ? it.keyname.split(" ")[0] : it.keyname
        );
        const names = namelist.join(",");
        this.setValue(this.selectFormdata.fieldname, String(names));
        // 下拉字段带出过程
        if (this.selectFormdata.isexitvalue) {
          this.valuechage(
            names,
            this.selectFormdata,
            this.selectFormdataIndex,
            this.selectFormdataPIndex
          ); //判断数据带出
        }
      } else {
        //单选树
        this.setValue(
          this.selectFormdata.fieldname,
          data.keyname.indexOf(" ") != -1
            ? data.keyname.split(" ")[0]
            : data.keyname
        );
        this.setValue(
          this.selectFormdata.popupdatefield,
          data[this.selectFormdata.popbackkeyid]
        );
        // 下拉字段带出过程
        if (this.selectFormdata.isexitvalue) {
          this.valuechage(
            data.keyname.indexOf(" ") != -1
              ? data.keyname.split(" ")[0]
              : data.keyname,
            this.selectFormdata,
            this.selectFormdataIndex,
            this.selectFormdataPIndex
          );
        }
        //转化字段带出过程
        this.loopData.forEach((item) => {
          item.children.forEach((it) => {
            if (
              it.isexitvalue &&
              it.fieldname === this.selectFormdata.popupdatefield
            ) {
              this.valuechage(
                data[this.selectFormdata.popbackkeyid],
                it,
                this.selectFormdataIndex,
                this.selectFormdataPIndex
              ); //判断数据带出
            }
          });
        });
        this.childrenData[this.selectFormdataPIndex].form.loopData =
          this.loopData;
      }
    },
    showComBoBoxEvent(list, index, pindex) {
      this.selectFormdata = list;
      this.selectFormdataIndex = index;
      this.selectFormdataPIndex = pindex;
      if (
        !list.ispoptree &&
        list.listsql != "@selectmonth" &&
        list.listsql != "@selectyear"
      ) {
        // 普通下拉菜单
        this.comboboxNoispoptreefocus(list, list.listsql, list.controltype);
      } else if (
        list.controltype === "combobox" &&
        list.ispoptree &&
        list.poptreename != "emptree" &&
        list.listsql != "@selectmonth" &&
        list.listsql != "@selectyear"
      ) {
        // 非员工树
        this.whichTreeName = "";
        this.updateformstr();
        this.isMultiselTree = list.multiseltree;
        this.$refs.popTreeNode.module =
          this.formConfig.moduleno || this.formautoid;
        this.$refs.popTreeNode.treename = list.poptreename;
        this.$refs.popTreeNode.fieldname = this.selectFormdata.fieldname;
        this.$refs.popTreeNode.editstate = 2;
        this.$refs.popTreeNode.showEmpTreePop("数据");
      } else if (
        (list.controltype == "combobox" || list.controltype == "edit") &&
        list.ispoptree &&
        list.poptreename === "emptree" &&
        list.listsql != "@selectmonth" &&
        list.listsql != "@selectyear"
      ) {
        // 员工数
        this.whichTreeName = "employee";
        this.updateformstr();
        getQueryEmpModuleNo({
          moduleno: this.formautoid,
          username: this.userInfo.username,
          iswf: true,
          fieldname: list.fieldname,
        }).then((res) => {
          this.selectFormdata = list;
          this.quemoduleno = res.data[0].moduleno;
          this.$refs.popTreeNode.module = this.quemoduleno;
          this.$refs.popTreeNode.treename = list.poptreename;
          this.isMultiselTree = list.multiseltree;
          this.$refs.popTreeNode.fieldname = this.selectFormdata.fieldname;
          this.$refs.popTreeNode.editstate = 2;
          this.$refs.popTreeNode.showEmpTreePop("数据");
        });
      } else if (list.controltype === "lookupcombobox") {
        this.comboboxNoispoptreefocus(list, list.listsql, list.controltype);
      }
    },
    // 工号自动带出
    changeEmpname(val, list) {
      let listval = list.webContent;
      if (
        list.ispoptree &&
        list.poptreename == "emptree" &&
        (list.controltype == "combobox" || list.controltype == "edit")
      ) {
        getEmpInfo({
          empcode: listval,
          moduleno: this.$route.query.module || 201,
          username: this.userInfo.username,
        })
          .then((res) => {
            if (res.data.length === 0) {
              //没有查到记录直接使用输入值进行带出
              listval = "";
              this.setValue(list.fieldname, listval);
              this.valuechage(
                listval,
                list,
                this.selectFormdataIndex,
                this.selectFormdataPIndex
              );
            } else if (res.data.length === 1) {
              //只有1笔记录，直接赋值
              listval = res.data[0].empcode;
              this.setValue(list.fieldname, listval);
              this.valuechage(
                listval,
                list,
                this.selectFormdataIndex,
                this.selectFormdataPIndex
              );
            } else {
              this.selectFormdata = list;
              this.$refs.refEmpDataTable.getEmpData(res.data);
              this.$refs.refEmpDataTable.showEmpDataTablePicker = true;
            }
          })
          .catch((e) => {
            this.valuechage(
              listval,
              list,
              this.selectFormdataIndex,
              this.selectFormdataPIndex
            );
          });
      } else {
        this.valuechage(
          listval,
          list,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
    },
    choiceSelect(obj) {
      let v = obj["empcode"];
      this.setValue(this.selectFormdata.fieldname, v);
      this.valuechage(
        v,
        this.selectFormdata,
        this.selectFormdataIndex,
        this.selectFormdataPIndex
      );
    },
    // select相关
    comboboxNoispoptreefocus(list, data, controltype) {
      const selectListFormData = list.webContent;
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "请求中...",
      });
      this.updateformstr();

      this.formstr[this.data.dtkeyfield] = this.macceptid;
      getListSource({
        iswf: true,
        moduleno: this.formautoid,
        fieldname: list.fieldname,
        username: this.userInfo.username,
        listsql: data,
        formstr: JSON.stringify(this.formstr),
        list_source_type: list.list_source_type,
        list_source_name: list.list_source_name,
        list_api_type: list.list_api_type,
        list_api_url: list.list_api_url,
        list_api_mode: list.list_api_mode,
        list_api_headerlist: list.list_api_headerlist,
      }).then((res) => {
        Toast.clear();
        if (controltype === "combobox") {
          this.comboboxDefaultIndex = 0;
          this.showComboboxPicker = true;
          let tempdata = [];
          //普通下拉框只取第一个属性值，并且明明为dicvalue
          res.data.forEach((item) => {
            tempdata.push({ dicvalue: item[Object.keys(item)[0]] });
          });
          this.comboboxChoices = tempdata;
          if (selectListFormData) {
            for (let i = 0; i < tempdata.length; i++) {
              if (tempdata[i].dicvalue == selectListFormData) {
                this.comboboxDefaultIndex = i;
                break;
              }
            }
          }
        } else if (controltype === "lookupcombobox") {
          this.lookupcomboboxList = [];
          let tempdata2 = { head: [{ name: [], width: [] }], data: [] },
            li = [];
          if (res.data.length > 0) {
            Object.keys(res.data[0]).forEach((item) => {
              tempdata2.head[0].name.push(item);
              tempdata2.head[0].width.push(item.toString().length);
            });
          }
          //表格下拉框需要新增表头数据
          for (let i = 0; i < res.data.length; i++) {
            var tp = [];
            for (let j = 0; j < tempdata2.head[0].name.length; j++) {
              let v = res.data[i][tempdata2.head[0].name[j]];
              v =
                v === null
                  ? ""
                  : v.toString().toLowerCase() === "true"
                  ? "是"
                  : v.toString().toLowerCase() === "false"
                  ? "否"
                  : v;
              tp.push(v);
              if (v != null) {
                let vl = v.toString().length;
                tempdata2.head[0].width[j] =
                  tempdata2.head[0].width[j] >= vl
                    ? tempdata2.head[0].width[j]
                    : vl;
              }
            }
            li.push(tp);
          }
          for (let j = 0; j < tempdata2.head[0].name.length; j++) {
            let name = tempdata2.head[0].name[j];
            tempdata2.head[0].name[j] =
              name.indexOf("_") > -1 ? name.split("_")[0] : name;
          }
          this.lookupcomboboxList = li;
          let isLookupcomboboxActiveIndex = 0;
          this.currentPage2 = 1;
          if (selectListFormData) {
            for (let i = 0; i < this.lookupcomboboxList.length; i++) {
              if (selectListFormData == this.lookupcomboboxList[i][0]) {
                this.lookupcomboboxList[i].push("isLookupcomboboxActive");
                isLookupcomboboxActiveIndex = i;
              }
            }
            this.currentPage2 = Math.ceil(
              (isLookupcomboboxActiveIndex + 1) / this.pageSize2
            );
          }
          this.lookupcomboboxTotal = this.lookupcomboboxList.length;
          this.bigArray = paging(this.pageSize2, this.lookupcomboboxList);
          tempdata2.data = this.bigArray[this.currentPage2 - 1];
          this.lookupcomboboxChoices = tempdata2;
          this.showLookupComboboxPicker = true;
        }
      });
    },
    // lookupcombobox控件
    onLookupComboboxConfirm(obj, index) {
      this.setValue(this.selectFormdata.fieldname, obj[0]);
      // 下拉字段带出过程
      if (this.selectFormdata.isexitvalue) {
        this.valuechage(
          obj[0],
          this.selectFormdata,
          this.selectFormdataIndex,
          this.selectFormdataPIndex
        );
      }
      this.showLookupComboboxPicker = false;
    },
    lookupcomboboxPageChange() {
      this.lookupcomboboxChoices.data = this.bigArray[this.currentPage2 - 1];
    },
    updateformstr() {
      this.logdetail = "";
      let logdetailarr = [];
      this.loopData.forEach((item) => {
        item.children.forEach((it) => {
          if (it.fieldname && it.fieldname != "undefined") {
            this.formstr[it.fieldname] =
              it.formdata === null || it.formdata === undefined
                ? "null"
                : it.formdata === "" &&
                  (it.controltype === "datetime" ||
                    this.floatarry.indexOf(it.fielddatatype) != -1 ||
                    this.intarry.indexOf(it.fielddatatype) != -1)
                ? "null"
                : it.formdata === ""
                ? it.formdata
                : it.controltype === "datetime"
                ? parseTime(it.formdata, "{y}-{m}-{d}")
                : it.controltype === "checkbox"
                ? it.formdata === "是"
                  ? "true"
                  : it.formdata === "否"
                  ? "false"
                  : it.formdata.toString()
                : it.controltype === "longdatetime"
                ? parseTime(it.formdata, "{y}-{m}-{d} {h}:{i}:{s}")
                : it.formdata && it.controltype === "colorcombobox"
                ? hex2int(it.formdata)
                : it.formdata.toString();
            if (
              it.maskeditstr === "Time" ||
              it.maskeditstr === "SelectTime" ||
              it.maskeditstr === "!90:00;1;_"
            ) {
              it.formdata =
                it.formdata && typeof it.formdata == "string"
                  ? it.formdata.substr(0, 5)
                  : it.formdata;
              this.formstr[it.fieldname] =
                this.formstr[it.fieldname] &&
                typeof this.formstr[it.fieldname] == "string"
                  ? this.formstr[it.fieldname].substr(0, 5)
                  : this.formstr[it.fieldname];
            }
            if (it.controltype === "checkgroup") {
              if (
                it.formdata &&
                typeof it.formdata == "object" &&
                it.formdata.length > 0
              ) {
                this.formstr[it.fieldname] = it.formdata.join(",");
              } else {
                this.formstr[it.fieldname] = "";
              }
            }
            if (it.controltype === "selectcombobox") {
              if (
                it.formdata &&
                typeof it.formdata == "object" &&
                it.formdata.length > 0
              ) {
                this.formstr[it.fieldname] = it.formdata.join(",");
              } else {
                this.formstr[it.fieldname] = "";
              }
            }
            if (it.haschange && this.status === "modify") {
              logdetailarr.push(
                "{" +
                  it.fieldname +
                  "," +
                  it.chnname +
                  "," +
                  it.oldvalue +
                  "," +
                  it.newvalue +
                  "}"
              );
            }
          }
        });
      });
      this.logdetail = logdetailarr.join(",");
      if (this.formstr.hasOwnProperty("undefined")) {
        delete this.formstr["undefined"];
      }
      return this.formstr;
    },
    checkMustinput() {
      let check = false;
      for (let i = 0; i < this.b4TableData.length; i++) {
        const item = this.b4TableData[i];
        const index = i;
        for (let key in item) {
          const data = item[key];
          if (data.mustinput) {
            if (
              data.webContent !== 0 &&
              data.webContent !== false &&
              !data.webContent
            ) {
              check = true;
              Notify(
                "子表" +
                  this.data.formname +
                  "的第" +
                  (index + 1) +
                  "行的" +
                  data.chnname +
                  "必填"
              );
              return check;
            }
          }
        }
      }
      return check;
    },
    // 点击表格行
    changeAuditDataByTd(val) {
      // this.data.tableData.forEach(element => {
      //   element.radioSelect.select = false
      // });
      // val.radioSelect.select = true;
      // this.$forceUpdate();
      // this.selectObj = val;
    },
    copyItem() {
      let arr = this.tableData.filter((item) => {
        return item.radioObj.webContent == true;
      });
      if (arr.length == 0) {
        Notify("请选择1条数据");
        return;
      } else if (arr.length > 1) {
        Notify("不支持批量复制");
        return;
      }
      let copyIndex = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].radioObj.webContent == true) {
          copyIndex = i;
          break;
        }
      }
      this.visitXq({}, copyIndex, "copy");
      // this.newformautoid = 0;
    },
    deleteItem() {
      let arr = this.tableData.filter((item) => {
        return item.radioObj.webContent == true;
      });
      if (arr.length == 0) {
        Notify("请选择数据");
        return;
      }
      Dialog.confirm({
        title: "系统提示",
        message: "是否确认删除？",
      })
        .then(() => {
          const id = [];
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].radioObj.webContent == true) {
              id.push(this.childrenData[i].acceptid + "");
            }
          }
          const params = {
            guid: createGguid(), //
            formautoid: this.data.autoid,
            mkeyname: this.data.moduleConfig.mkeyname,
            mtablename: this.data.moduleConfig.mtablename,
            mviewname: this.data.moduleConfig.mviewname,
            isall: false,
            autoidlist: id.join(","), //
            moduleqyfilter: "",
            specfilter: this.data.moduleConfig.specfilter,
            querysql: "",
            username: this.userInfo.username,
            optionfilter: [],
          };
          deleteWorkFlowList(params).then((res) => {
            this.$emit("getChildTableDataFun", {});
            Toast("删除成功");
            this.$forceUpdate();
          });
        })
        .catch(() => {});
    },
    upDateSelectArr() {
      this.tableData.forEach((item) => {
        item.radioObj.webContent = false;
      });
      const columns = Object.keys(this.tableData[0]);
      // 初始化结果数组
      const resultArray = columns.map((field) => {
        let hasValidNumber = false; // 标记是否有有效的数字
        let sum = 0;
        let count = 0; // 记录有效数字的个数
        let maxValue = -Infinity; // 初始值为负无穷
        let minValue = Infinity; // 初始值为正无穷
        this.tableData.forEach((item) => {
          // if(item[field].footerkind == 'skSum'){
          const value = Number(
            item[field]
              ? item[field].webContent == "" || item[field].webContent == null
                ? NaN
                : item[field].webContent
              : NaN
          );
          if (!isNaN(value)) {
            sum += value;
            hasValidNumber = true; // 标记有有效的数字
            count++; // 有效数字个数加 1
            if (value > maxValue) {
              maxValue = value; // 更新最大值
            }
            if (value < minValue) {
              minValue = value; // 更新最小值
            }
          }
          // }
          // if()
        });
        let obj = {
          webContent: "",
          webFixed: this.tableData[0]?.[field]?.webFixed || false,
          footerkind: this.tableData[0]?.[field]?.footerkind || "skNone",
        };
        const footerkind = this.tableData[0]?.[field]?.footerkind;
        if (footerkind == "skSum") {
          obj.webContent = hasValidNumber ? sum.toFixed(2) : "";
        } else if (footerkind == "skAverage") {
          obj.webContent = count > 0 ? (sum / count).toFixed(2) : "";
        } else if (footerkind == "skCount") {
          obj.webContent = this.tableData.length;
        } else if (footerkind == "skMax") {
          obj.webContent = hasValidNumber ? maxValue.toFixed(2) : "";
        } else if (footerkind == "skMin") {
          obj.webContent = hasValidNumber ? minValue.toFixed(2) : "";
        }
        return obj;
      });
      // console.log(resultArray,'ewffefefefefeefe');
      resultArray[0].webContent = "汇总";
      this.huiZongArr = resultArray;

      this.$forceUpdate();
    },
    changePage() {
      this.tableData = this.b4TableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
      this.childrenData = this.b4ChildrenData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
      this.upDateSelectArr();
      this.$forceUpdate();
    },
    visitXq(val, index, addtype = "add") {
      const loading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "数据读取中...",
      });
      this.selectIndex = index;

      this.selectObj = this.childrenData[index];

      const config = this.data.baseinfo.forminfo;
      const usefieldpri = config[0].usefieldpri;
      const colcount = config[0].colcount;
      const labelwidth = config[0].labelwidth;
      const controlwidth = config[0].controlwidth;
      const mviewname = config[0].mviewname;
      const mkeyname = config[0].mkeyname;
      const formfieldlist = config[0].formfieldlist;
      getWFFormFieldDetail({
        formautoid: this.data.autoid,
        userid: this.userInfo.userid,
        langid: localStorage.getItem("langid") || 0,
        usefieldpri: usefieldpri,
        colcount: colcount,
        labelwidth: labelwidth,
        controlwidth: controlwidth,
        mviewname: mviewname,
        mkeyname: mkeyname,
        formfieldlist: formfieldlist,
        autoid: this.selectObj.acceptid,
        nodeid: this.nodeid,
        isapp: 1,
      }).then((res) => {
        const fieldvalue = res.fieldvalue;
        fieldvalue.forEach((item, index) => {
          item.showkeyboard = true;

          for (let i in item) {
            this.selectObj.form.loopData.forEach((value) => {
              value.children.forEach((it) => {
                if (i == it.fieldname) {
                  if (it.controltype == "checkgroup") {
                    if (item[i]) {
                      it.webContent = item[i].split(",");
                      it.formdata = item[i].split(",");
                    } else {
                      it.webContent = [];
                      it.formdata = [];
                    }
                  } else if (it.controltype == "selectcombobox") {
                    if (item[i]) {
                      it.webContent = item[i].split(",");
                      it.formdata = item[i].split(",");
                    } else {
                      it.webContent = [];
                      it.formdata = [];
                    }
                  } else {
                    it.webContent = item[i];
                    it.formdata = item[i];
                  }
                }
              });
            });
          }
          console.log(this.selectObj);
        });
        if (addtype == "copy") {
          this.selectObj.acceptid = 0;
        }
        this.$nextTick(() => {
          this.show = true;
          this.showIt = true;
          this.$forceUpdate();
        });
        loading.clear();
      });
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        const check = this.$refs.refChildInfo.checkmustinput();
        const checkReg = this.$refs.refChildInfo.checkReg();
        if (check) {
          done(false);
          return;
        }
        if (checkReg) {
          done(false);
          return;
        }
        this.$refs.refChildInfo.beforeAction().then((res) => {
          if (res.status == "success") {
            if (res.returnData) {
              this.$emit("getChildTableDataFun", res.returnData);
              this.show = false;
              setTimeout(() => {
                this.showIt = false;
              }, 300);
              done();
            }
          } else if (res.status == "fail") {
            done(false);
          }
        });
      } else {
        this.show = false;
        setTimeout(() => {
          this.showIt = false;
        }, 300);
        done();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.table_box {
  display: flex;
  width: 100%;

  .contentTable {
    width: 100%;
    overflow: auto;
    flex: 1;
    /deep/.van-cell {
      padding-left: 0.5rem !important;
      padding-right: 0.35rem !important;

      &.fieldDisabled {
        background: #efefef !important;
        pointer-events: none;

        .van-cell__title,
        .van-cell__value {
          color: #333333 !important;

          .van-field__control {
            color: #333333 !important;
            -webkit-text-fill-color: #333333 !important;
          }
        }
      }
    }
  }
  .table {
    width: 100%;
    border-spacing: 0px;
  }

  tr {
    td:nth-child(1) {
      border-left: 2px solid #dcdfe6;
    }

    th,
    td {
      // padding: 6px 10px;
      text-align: center;
      border-bottom: 2px solid #dcdfe6;
      border-right: 2px solid #dcdfe6;
      // padding-top: 6px;
      position: relative;
      .comm_box {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // line-height: 52px;
        // overflow: hidden;
        // word-break: break-all;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate3d(-50%, -50%, 0px);
        width: 100%;
        .cellinput {
          width: 100%;
          // overflow: hidden;
          // word-break: break-all;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          text-align: center;
          padding: 5px;
        }
        .cell-text-input {
          padding: 0 !important;
          border: 1px solid #ccc !important;
          padding-left: 5px !important;
        }
        .boolean_box {
          .van-checkbox {
            justify-content: center;

            /deep/.van-checkbox__icon--checked {
              .van-icon {
                color: #fff !important;
                background-color: #1989fa !important;
                border-color: #1989fa !important;
              }
            }

            /deep/.van-checkbox__icon--disabled .van-icon {
              background-color: #fff;
            }
          }
        }

        .input_box {
          width: 180px;

          .van-cell {
            font-size: 24px;
            border: 2px solid #d2d2d2;
            border-radius: 10px;
            padding: 8px 16px;
          }
        }
      }
    }
  }

  .top {
    position: sticky;
    top: 0;
    font-size: 28px;
    background: #e9f3fd;
    height: 64px;

    th:nth-child(1) {
      border-left: 2px solid #dcdfe6;
    }

    th {
      border-top: 2px solid #dcdfe6;
    }

    .thTitleIsFixed {
      position: sticky !important;
      z-index: 9;
      background: #e9f3fd !important;
    }
  }
  .footer {
    background: #ffd3b8 !important;
    .thTitleIsFixed {
      position: sticky !important;
      z-index: 9;
      background: #ffd3b8 !important;
    }
  }
  .cont {
    height: 64px;
    font-size: 24px;
    .tdTitleIsFixed {
      position: sticky !important;
      z-index: 9;
      background: #fff !important;
    }
  }

  .cont:nth-child(2n-1) {
    background: #f5f5f5;
    .tdTitleIsFixed {
      position: sticky !important;
      z-index: 9;
      background: #f5f5f5 !important;
    }
  }

  .nodata {
    td {
      font-size: 28px;
    }
  }
}
.childInfoDialog {
  height: 97% !important;
  width: 95% !important;
  top: 50% !important;
  /deep/.van-dialog__header {
    display: none !important;
  }
  /deep/.van-dialog__content {
    height: calc(100% - 1.28rem) !important;
    overflow: auto;
  }
}

.isLookupcomboboxActiveBg {
  background: #9cd6ff !important;
}

.custom-button {
  width: 52px;
  color: #fff !important;
  font-size: 20px;
  line-height: 36px;
  height: 36px;
  text-align: center;
  background-color: #1989fa;
  border-radius: 100px;
}
.childTableBody {
  /deep/.van-slider--disabled {
    opacity: 1;
  }
}

.tdTitleIsFixed{
  .cellinput{
    cursor: pointer !important;
  }
}
</style>